import type { iCustomerInvoice } from "@sdk/bookings/booking-model";
import { CreateEntitySlice } from "../../utils/entity-slice-creator";
import { customerInvoicesDefaultQueryConfig } from "./customer-invoices-default-query";

export const {
  slice: CustomerInvoicesSlice,
  reducers: CustomerInvoicesSliceReducer,
  actions: {
    setEntityQueryResults: setCustomerInvoicesQueryResults,
    setEntity: setCustomerInvoice,
    setEntities: setCustomerInvoices,
    patchEntity: patchCustomerInvoice,
    addNewEntity: addNewCustomerInvoice,
    setEntityFetchingStatus: setCustomerInvoiceFetchingStatus,
    setEntitiesFetchingStatus: setCustomerInvoicesFetchingStatus,
    setEntityFailedStatus: setCustomerInvoiceFailedStatus,
    setEntityQueryError: setCustomerInvoicesQueryError,
    resetQuery: resetCustomerInvoicesQuery,
    setQueryList: setCustomerInvoiceQueryList,
  },
} = CreateEntitySlice<iCustomerInvoice>({
  sliceName: "customerInvoices",
  queryAliasResolver: (queryAlias: string) => {
    if (queryAlias === "all") {
      return {
        ...customerInvoicesDefaultQueryConfig,
        alias: "all",
      };
    }
  },
});
